import { Routes } from '@angular/router';
import {HomeComponent} from './home/home.component';
import {MessagesComponent} from './messages/messages.component';
import {MessageDetailsComponent} from './messages/message-details/message-details.component';
import {OpenMessagesComponent} from './messages/open-messages/open-messages.component';
import { appEntryGuard, authenticatedGuard } from './auth/auth.guard';

export const routes: Routes = [
  { path: '', component: HomeComponent, canActivate: [appEntryGuard], pathMatch: 'full' },

  { path: 'messages', component: MessagesComponent, canActivate: [authenticatedGuard] },
  { path: 'open-messages', component: OpenMessagesComponent, canActivate: [authenticatedGuard] },
  { path: 'messages/:messageId', component: MessageDetailsComponent, canActivate: [authenticatedGuard] },
];
